module.exports = __webpack_public_path__ + "static/img/amara.a8bfdae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/amara.png
// module id = RIvz
// module chunks = 1